import { render, staticRenderFns } from "./LinkageListItem.vue?vue&type=template&id=641b165e&scoped=true&"
import script from "./LinkageListItem.vue?vue&type=script&lang=js&"
export * from "./LinkageListItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkageListItem.vue?vue&type=style&index=0&id=641b165e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b165e",
  null
  
)

export default component.exports